<template>
  <router-view />
</template>

<script>
import store, { name } from '@/modules/provider/store';

export default {
  name: 'ProviderWrapper',
  data: () => ({
    page: {
      title: 'Proveedor',
      icon: 'fas fa-user-tie',
      routes: ['Proveedor'],
    },
  }),
  provide() {
    return {
      page: this.page,
    };
  },
  created() {
    this.$store.registerModule(name, store);
  },
  destroyed() {
    this.$store.unregisterModule(name);
  },
};
</script>
